import React , {useEffect} from 'react';
import './SideFooter.css';
import { Link } from 'react-router-dom';
import Aos from 'aos';
import "aos/dist/aos.css";

const SideFooter = () => {

    useEffect(() => {
        Aos.init( {  duration: 1200 } )
      } , []);


  return (
    <div className='section container-md' >
          
        <div className="grid_footer_area">

        <div data-aos-duration="250" data-aos="fade-right" data-aos-delay="0" data-aos-easing="linear" data-aos-mirror="true" >
          <img src="/images/icons/logo.png" alt="" className="identity_logo" />
          <h1 className="headline_info"> البوصلة السياحية </h1>
        </div>

        <div className='footer_card' data-aos-duration="350" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" >

        <div className="top_line_footer"></div>
        <div className="mt-1"></div>
        <h1 className="headline_footer">  الاماكن السياحية </h1>
        
        <ul className="footer_list">
        
          <li>
              <Link to="/places/mkS9IxX96uOtgPn6vV1k">
                   جازان
              </Link>
          </li>

          <li>
              <Link to="/places/kxCkpBhprvFWYPHExiW1">
                    الرياض
              </Link>
          </li>

          <li>
              <Link to="/places/tZQfb3hgtrfVvD4fAu3e">
                    جدة 
              </Link>
          </li>

        </ul>

        </div>

        <div className='footer_card' data-aos-duration="370" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" >

        <div className="top_line_footer"></div>
        <div className="mt-1"></div>
        <h1 className="headline_footer"> الرحلات والبكجات  </h1>

        <ul className="footer_list">
        
          <li>
              <Link to="/package/TEH1JbYrfEGUYOszI9BN">
                  رحلة جبال فيفا 
              </Link>
          </li>

          <li>
              <Link to="/package/XmHVzVEomQcjV886sRAS">
                   رحلة وادي لجب 
              </Link>
          </li>

          <li>
              <Link to="/package/p43Rxw9vZP3lUHnYbuZi">
                    رحلة جزيرة فرسان 
              </Link>
          </li>

        </ul>

        </div>

        <div className='footer_card'  data-aos-duration="390" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" >

        <div className="top_line_footer"></div>
        <div className="mt-1"></div>
        <h1 className="headline_footer">  التجارب السياحية </h1>

        <ul className="footer_list">
        
          <li>
              <Link to="/experinces/Kdt2RqZ5AXMRGEEZ4CnO">
              جولة في مدينة الرياض القديمة
              </Link>
          </li>

          <li>
              <Link to="/experinces/bHcprmyLc9eDbG19Qj2U">
              رحلة الغوص في البحر الأحمر
              </Link>
          </li>

          <li>
              <Link to="/experinces/1rq0RJcuXRdkiX7z2P9O">
              جولة في الصحراء على ظهر الجمال
              </Link>
          </li>

        </ul>

        </div>

        </div>
    </div>
  )
}

export default SideFooter